import { FormProvider } from 'react-hook-form';
import { FormInput } from '@/components/form/form-input';
import { SmartSuggestionFormShell } from '@/features/inventory/pages/smart-suggestion/form-shell';
import { useGiftCardValueForm } from '../../hooks/gift-card-value-hooks';

const GiftCardValueSettingForm = () => {
  const { id, form, isLoading, isSaving, handleReset, handleDelete, onSubmit } =
    useGiftCardValueForm();

  return (
    <div className="space-y-6">
      <FormProvider {...form}>
        <SmartSuggestionFormShell
          id={id}
          title={id ? 'Edit Gift Card Value' : 'New Gift Card Value'}
          description="A quick pick offered when buying a gift card, in the widget and on the gift card form. Values are listed smallest first."
          isLoading={isLoading}
          isSaving={isSaving}
          onSubmit={form.handleSubmit(onSubmit)}
          onReset={handleReset}
          onDelete={handleDelete}
        >
          <FormInput
            name="value"
            label="Value"
            type="number"
            min={0}
            step="0.01"
            placeholder="e.g. 50"
            prefixElement={<span className="pr-2">€</span>}
            onWheel={e => e.currentTarget.blur()}
            required
          />
        </SmartSuggestionFormShell>
      </FormProvider>
    </div>
  );
};

export default GiftCardValueSettingForm;
